/* models/file_dropper.js */ function _(require, module, exports, __esModule, __esExport) {
    var _a, _b, _c;
    __esModule();
    const tslib_1 = require("tslib");
    const bokeh_events_1 = require("@bokehjs/core/bokeh_events");
    const dom_1 = require("@bokehjs/core/dom");
    const kinds_1 = require("@bokehjs/core/kinds");
    const input_widget_1 = require("@bokehjs/models/widgets/input_widget");
    const inputs = tslib_1.__importStar(require("@bokehjs/styles/widgets/inputs.css"));
    const filedropper_css_1 = tslib_1.__importDefault(require("c03dd3c931") /* ../styles/models/filedropper.css */);
    class UploadEvent extends bokeh_events_1.ModelEvent {
        constructor(data) {
            super();
            this.data = data;
        }
        get event_values() {
            return { model: this.origin, data: this.data };
        }
    }
    exports.UploadEvent = UploadEvent;
    _a = UploadEvent;
    UploadEvent.__name__ = "UploadEvent";
    (() => {
        _a.prototype.event_name = "upload_event";
    })();
    class DeleteEvent extends bokeh_events_1.ModelEvent {
        constructor(data) {
            super();
            this.data = data;
        }
        get event_values() {
            return { model: this.origin, data: this.data };
        }
    }
    exports.DeleteEvent = DeleteEvent;
    _b = DeleteEvent;
    DeleteEvent.__name__ = "DeleteEvent";
    (() => {
        _b.prototype.event_name = "delete_event";
    })();
    class FileDropperView extends input_widget_1.InputWidgetView {
        constructor() {
            super(...arguments);
            this._file_pond = null;
            this._transfer_in_process = null;
        }
        initialize() {
            super.initialize();
            window.FilePond.registerPlugin(window.FilePondPluginImagePreview);
            window.FilePond.registerPlugin(window.FilePondPluginPdfPreview);
            window.FilePond.registerPlugin(window.FilePondPluginFileValidateType);
            window.FilePond.registerPlugin(window.FilePondPluginFileValidateSize);
        }
        connect_signals() {
            super.connect_signals();
            const { disabled, layout, max_file_size, max_files, max_total_file_size, multiple } = this.model.properties;
            this.on_change([disabled, max_file_size, max_files, max_total_file_size, multiple, layout], () => {
                this._file_pond?.setOptions({
                    acceptedFileTypes: this.model.accepted_filetypes,
                    allowMultiple: this.model.multiple,
                    disabled: this.model.disabled,
                    maxFiles: this.model.max_files,
                    maxFileSize: this.model.max_file_size,
                    maxTotalFileSize: this.model.max_total_file_size,
                    stylePanelLayout: this.model.layout,
                });
            });
        }
        remove() {
            if (this._file_pond) {
                this._file_pond.destroy();
            }
            super.remove();
        }
        stylesheets() {
            return [...super.stylesheets(), filedropper_css_1.default];
        }
        _render_input() {
            const { multiple, disabled } = this.model;
            return this.input_el = (0, dom_1.input)({ type: "file", class: inputs.input, multiple, disabled });
        }
        render() {
            super.render();
            this._file_pond = window.FilePond.create(this.input_el, {
                acceptedFileTypes: this.model.accepted_filetypes,
                allowMultiple: this.model.multiple,
                credits: false,
                disabled: this.model.disabled,
                maxFiles: this.model.max_files,
                maxFileSize: this.model.max_file_size,
                maxTotalFileSize: this.model.max_total_file_size,
                server: {
                    process: (_, file, __, load, error, progress) => {
                        void this._process_upload(file, load, error, progress);
                    },
                    fetch: null,
                    revert: (id, load) => {
                        this.model.trigger_event(new DeleteEvent({ name: id }));
                        load();
                    },
                },
                stylePanelLayout: this.model.layout,
            });
        }
        async _process_upload(file, load, error, progress) {
            const buffer_size = this.model.chunk_size;
            const chunks = Math.ceil((file.size + 1) / buffer_size); // +1 is for empty files
            let abort_flag = false;
            new Promise(async (resolve, reject) => {
                for (let i = 0; i < chunks; i++) {
                    if (abort_flag) {
                        reject(file.name);
                        return;
                    }
                    const start = i * buffer_size;
                    const end = Math.min(start + buffer_size, file.size);
                    this.model.trigger_event(new UploadEvent({
                        chunk: i + 1,
                        data: await file.slice(start, end).arrayBuffer(),
                        name: file._relativePath || file.name,
                        total_chunks: chunks,
                        type: file.type,
                    }));
                    progress(true, end, file.size);
                }
                load(file.name);
                resolve(file.name);
            }).catch(() => error("Upload failed."));
            return { abort: () => {
                    abort_flag = true;
                } };
        }
    }
    exports.FileDropperView = FileDropperView;
    FileDropperView.__name__ = "FileDropperView";
    exports.DropperLayout = (0, kinds_1.Enum)("integrated", "compact", "circle");
    class FileDropper extends input_widget_1.InputWidget {
        constructor(attrs) {
            super(attrs);
        }
    }
    exports.FileDropper = FileDropper;
    _c = FileDropper;
    FileDropper.__name__ = "FileDropper";
    FileDropper.__module__ = "panel.models.file_dropper";
    (() => {
        _c.prototype.default_view = FileDropperView;
        _c.define(({ Any, List, Bool, Int, Nullable, Str }) => ({
            accepted_filetypes: [List(Str), []],
            chunk_size: [Int, 10000000],
            max_file_size: [Nullable(Str), null],
            max_files: [Nullable(Int), null],
            max_total_file_size: [Nullable(Str), null],
            mime_type: [Any, {}],
            multiple: [Bool, true],
            layout: [Nullable(exports.DropperLayout), null],
        }));
    })();
}
